var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBetaNotext(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 3C0 1.34315 1.34315 0 3 0H51C52.6569 0 54 1.34315 54 3V51C54 52.6569 52.6569 54 51 54H3C1.34315 54 0 52.6569 0 51V3Z",
    fill: "#f8faff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.896 22.7387C35.792 21.5547 36.3333 19.9653 36.3333 18.3333C36.3333 14.4267 32.5947 11 28.3333 11C23.9227 11 20.3333 14.5893 20.3333 19V36.3333C20.3333 38.5387 18.5387 40.3333 16.3333 40.3333H15V43H16.3333C19.6187 43 22.36 40.6107 22.9013 37.4747C24.7067 39.2293 27.1627 40.3333 29.6667 40.3333C34.8133 40.3333 39 36.1467 39 31C39 27.4613 37.5573 24.5893 34.896 22.7387ZM29.6667 37.6667C26.7893 37.6667 23.896 35.5413 23 32.8V19C23 16.0587 25.392 13.6667 28.3333 13.6667C31.336 13.6667 33.6667 16.1733 33.6667 18.3333C33.6667 19.688 33.056 21.016 32.2027 21.6667H28.3333V24.3333H32.3013C34.96 25.6453 36.3333 27.8773 36.3333 31C36.3333 34.6773 33.344 37.6667 29.6667 37.6667Z",
    fill: "#8EABC6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBetaNotext);
export default __webpack_public_path__ + "static/media/beta-notext.409d2a05eb8fd4e1a679accece7c3cf5.svg";
export { ForwardRef as ReactComponent };